import React, { useEffect, useState } from 'react';
import api from '../api';
import PageHeader from '../components/PageHeader';
import { Avatar, Ic, Spinner } from '../components/ui';

const MODULES = [
  { key: 'bots',         label: 'Botlar',       actions: ['view', 'create', 'edit', 'delete', 'toggle'] },
  { key: 'flows',        label: 'Flowlar',      actions: ['view', 'create', 'edit', 'delete'] },
  { key: 'applications', label: 'Başvurular',   actions: ['view', 'edit', 'delete', 'export'] },
  { key: 'chat',         label: 'Canlı Sohbet', actions: ['view', 'send'] },
  { key: 'broadcasts',   label: 'Toplu Mesaj',  actions: ['view', 'send'] },
  { key: 'users',        label: 'Kullanıcılar', actions: ['view', 'create', 'edit', 'delete'] },
  { key: 'roles',        label: 'Roller',       actions: ['view', 'create', 'edit', 'delete'] },
  { key: 'settings',     label: 'Ayarlar',      actions: ['view', 'edit'] },
  { key: 'ai',           label: 'Yapay Zeka',   actions: ['view', 'edit'] },
];
const ACTION_LABELS = { view: 'Görüntüle', create: 'Oluştur', edit: 'Düzenle', delete: 'Sil', toggle: 'Aç/Kapat', send: 'Gönder', export: 'Dışa aktar' };

function ErrorBox({ text }) {
  if (!text) return null;
  return <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '10px 12px', borderRadius: 10, background: 'var(--danger-s)', color: 'var(--danger)', fontSize: 14, marginBottom: 14 }}><Ic n="alert" s={18} />{text}</div>;
}

export default function Users() {
  const [tab, setTab] = useState('admins');
  const [admins, setAdmins] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddAdmin, setShowAddAdmin] = useState(false);
  const [showEditAdmin, setShowEditAdmin] = useState(null);
  const [showAddRole, setShowAddRole] = useState(false);
  const [showEditRole, setShowEditRole] = useState(null);
  const [adminForm, setAdminForm] = useState({ username: '', password: '', role_id: '' });
  const [roleForm, setRoleForm] = useState({ display_name: '', color: '#6ab3f3', permissions: {} });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const me = localStorage.getItem('username');

  async function load() {
    setLoading(true);
    try { const [ar, rr] = await Promise.all([api.get('/users/admins'), api.get('/users/roles')]); setAdmins(ar.data); setRoles(rr.data); } catch (e) { /* noop */ }
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function addAdmin(e) {
    e.preventDefault(); setSaving(true); setError('');
    try { await api.post('/users/admins', adminForm); setShowAddAdmin(false); setAdminForm({ username: '', password: '', role_id: '' }); load(); }
    catch (err) { setError(err.response?.data?.error || 'Hata'); }
    setSaving(false);
  }
  async function updateAdmin(e) {
    e.preventDefault(); setSaving(true); setError('');
    try { await api.put(`/users/admins/${showEditAdmin.id}`, adminForm); setShowEditAdmin(null); load(); }
    catch (err) { setError(err.response?.data?.error || 'Hata'); }
    setSaving(false);
  }
  async function deleteAdmin(id) {
    if (!window.confirm('Bu kullanıcı silinsin mi?')) return;
    try { await api.delete(`/users/admins/${id}`); load(); } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  }
  async function toggleAdmin(admin) {
    try { await api.put(`/users/admins/${admin.id}`, { role_id: admin.role_id, is_active: !admin.is_active }); load(); } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  }
  function initRoleForm(role = null) {
    if (role) { setRoleForm({ display_name: role.display_name, color: role.color, permissions: role.permissions || {} }); setShowEditRole(role); }
    else {
      const emptyPerms = {};
      MODULES.forEach(m => { emptyPerms[m.key] = {}; m.actions.forEach(a => { emptyPerms[m.key][a] = false; }); });
      setRoleForm({ display_name: '', color: '#6ab3f3', permissions: emptyPerms }); setShowAddRole(true);
    }
  }
  function togglePerm(module, action) {
    setRoleForm(f => ({ ...f, permissions: { ...f.permissions, [module]: { ...f.permissions[module], [action]: !f.permissions[module]?.[action] } } }));
  }
  function setAllModule(module, val) {
    setRoleForm(f => {
      const np = { ...f.permissions, [module]: {} };
      MODULES.find(m => m.key === module)?.actions.forEach(a => { np[module][a] = val; });
      return { ...f, permissions: np };
    });
  }
  async function saveRole(e) {
    e.preventDefault(); setSaving(true); setError('');
    try {
      if (showEditRole) { await api.put(`/users/roles/${showEditRole.id}`, roleForm); setShowEditRole(null); }
      else {
        const name = roleForm.display_name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
        await api.post('/users/roles', { ...roleForm, name }); setShowAddRole(false);
      }
      load();
    } catch (err) { setError(err.response?.data?.error || 'Hata'); }
    setSaving(false);
  }
  async function deleteRole(id) {
    if (!window.confirm('Bu rol silinsin mi?')) return;
    try { await api.delete(`/users/roles/${id}`); load(); } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  }
  const closeRole = () => { setShowAddRole(false); setShowEditRole(null); };

  return (
    <div className="page-enter">
      <PageHeader
        title="Kullanıcılar ve roller"
        subtitle="Panel kullanıcılarını ve yetkilerini yönet"
        actions={tab === 'admins'
          ? <button className="btn btn-primary" onClick={() => { setShowAddAdmin(true); setError(''); setAdminForm({ username: '', password: '', role_id: roles[0]?.id || '' }); }}><Ic n="userPlus" s={18} />Kullanıcı ekle</button>
          : <button className="btn btn-primary" onClick={() => { initRoleForm(); setError(''); }}><Ic n="plus" s={18} />Yeni rol</button>}
      />

      <div className="tabs" style={{ marginBottom: 16 }}>
        <button className={'tab' + (tab === 'admins' ? ' active' : '')} onClick={() => setTab('admins')}>Kullanıcılar ({admins.length})</button>
        <button className={'tab' + (tab === 'roles' ? ' active' : '')} onClick={() => setTab('roles')}>Roller ({roles.length})</button>
      </div>

      {loading ? <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><Spinner /></div> : tab === 'admins' ? (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {!admins.length && <div className="empty-state"><div className="icon"><Ic n="users" s={44} /></div><p>Kullanıcı yok</p></div>}
          <div className="list">
            {admins.map(a => (
              <div key={a.id} className="list-row" style={{ flexWrap: 'wrap', opacity: a.is_active ? 1 : 0.7 }}>
                <Avatar id={a.id} name={a.username} size={44} />
                <div style={{ flex: '1 1 160px', minWidth: 0 }}>
                  <div className="flex-center gap-6" style={{ flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: 600, fontSize: 15 }}>{a.username}</span>
                    {a.username === me && <span className="badge badge-accent">siz</span>}
                    {!a.is_active && <span className="badge badge-danger">Pasif</span>}
                  </div>
                  <div className="flex-center gap-8" style={{ flexWrap: 'wrap', marginTop: 3 }}>
                    <span className="chip" style={{ background: (a.role_color || '#6ab3f3') + '22', color: a.role_color || 'var(--link)' }}>{a.role_display || '—'}</span>
                    <span className="text-muted" style={{ fontSize: 12.5 }}>Son giriş: {a.last_login ? new Date(a.last_login).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' }) : '—'}</span>
                  </div>
                </div>
                <div className="flex-center gap-6" style={{ marginLeft: 'auto' }}>
                  <label className="toggle" title={a.is_active ? 'Pasif yap' : 'Aktif yap'}><input type="checkbox" checked={!!a.is_active} onChange={() => toggleAdmin(a)} /><span className="toggle-slider" /></label>
                  <button className="btn btn-sm btn-ghost" onClick={() => { setShowEditAdmin(a); setAdminForm({ username: a.username, password: '', role_id: a.role_id, is_active: a.is_active }); setError(''); }}><Ic n="edit" s={15} />Düzenle</button>
                  <button className="btn btn-sm btn-danger" title="Sil" onClick={() => deleteAdmin(a.id)}><Ic n="trash" s={15} /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {roles.map(role => (
            <div key={role.id} className="card">
              <div className="flex-between" style={{ gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
                <div className="flex-center gap-10" style={{ minWidth: 0 }}>
                  <div className="ic-circle" style={{ width: 40, height: 40, background: (role.color || '#6ab3f3') + '22', color: role.color || 'var(--link)' }}><Ic n="shield" s={20} /></div>
                  <div style={{ minWidth: 0 }}>
                    <div className="flex-center gap-6"><span style={{ fontSize: 15.5, fontWeight: 600 }}>{role.display_name}</span>{role.is_system && <span className="badge badge-neutral">sistem</span>}</div>
                    <div className="text-muted" style={{ fontSize: 13 }}>{admins.filter(a => a.role_id === role.id).length} kullanıcı</div>
                  </div>
                </div>
                <div className="flex gap-6">
                  <button className="btn btn-sm btn-ghost" onClick={() => { initRoleForm(role); setError(''); }}><Ic n="edit" s={15} />Düzenle</button>
                  {!role.is_system && <button className="btn btn-sm btn-danger" onClick={() => deleteRole(role.id)} title="Sil"><Ic n="trash" s={15} /></button>}
                </div>
              </div>
              <div className="keep-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 240px), 1fr))', gap: 8 }}>
                {MODULES.map(mod => {
                  const perms = role.permissions?.[mod.key] || {};
                  const on = mod.actions.filter(a => perms[a]).length;
                  return (
                    <div key={mod.key} style={{ background: 'var(--bg2)', borderRadius: 10, padding: '10px 12px' }}>
                      <div className="flex-between" style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 7 }}>
                        {mod.label}<span style={{ fontSize: 12, color: on === mod.actions.length ? 'var(--success)' : on ? 'var(--warning)' : 'var(--text3)' }}>{on}/{mod.actions.length}</span>
                      </div>
                      <div className="flex gap-4" style={{ flexWrap: 'wrap' }}>
                        {mod.actions.map(ac => (
                          <span key={ac} className="chip" style={{ fontSize: 11.5, background: perms[ac] ? 'var(--success-s)' : 'var(--surface3)', color: perms[ac] ? 'var(--success)' : 'var(--text3)' }}>{ACTION_LABELS[ac]}</span>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {showAddAdmin && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowAddAdmin(false)}>
          <div className="modal">
            <h3>Yeni kullanıcı</h3>
            <ErrorBox text={error} />
            <form onSubmit={addAdmin}>
              <div className="input-group"><label>Kullanıcı adı</label><input className="input" value={adminForm.username} onChange={e => setAdminForm({ ...adminForm, username: e.target.value })} required /></div>
              <div className="input-group"><label>Şifre</label><input className="input" type="password" value={adminForm.password} onChange={e => setAdminForm({ ...adminForm, password: e.target.value })} required /></div>
              <div className="input-group" style={{ marginBottom: 20 }}><label>Rol</label>
                <select className="input" value={adminForm.role_id} onChange={e => setAdminForm({ ...adminForm, role_id: parseInt(e.target.value, 10) })} required>
                  <option value="">Rol seç</option>{roles.map(r => <option key={r.id} value={r.id}>{r.display_name}</option>)}
                </select>
              </div>
              <div className="flex gap-8" style={{ justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={() => setShowAddAdmin(false)}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Ekleniyor…' : 'Ekle'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showEditAdmin && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowEditAdmin(null)}>
          <div className="modal">
            <h3>{showEditAdmin.username}</h3>
            <ErrorBox text={error} />
            <form onSubmit={updateAdmin}>
              <div className="input-group"><label>Rol</label>
                <select className="input" value={adminForm.role_id} onChange={e => setAdminForm({ ...adminForm, role_id: parseInt(e.target.value, 10) })}>{roles.map(r => <option key={r.id} value={r.id}>{r.display_name}</option>)}</select>
              </div>
              <div className="input-group"><label>Yeni şifre (boş bırakırsan değişmez)</label><input className="input" type="password" value={adminForm.password} onChange={e => setAdminForm({ ...adminForm, password: e.target.value })} placeholder="Değiştirmek için yaz" /></div>
              <label className="flex-center gap-10" style={{ cursor: 'pointer', marginBottom: 20 }}>
                <span className="toggle"><input type="checkbox" checked={adminForm.is_active !== false} onChange={e => setAdminForm({ ...adminForm, is_active: e.target.checked })} /><span className="toggle-slider" /></span>Aktif
              </label>
              <div className="flex gap-8" style={{ justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={() => setShowEditAdmin(null)}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Kaydediliyor…' : 'Kaydet'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {(showAddRole || showEditRole) && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && closeRole()}>
          <div className="modal" style={{ maxWidth: 680, width: '100%' }}>
            <h3>{showEditRole ? `Rolü düzenle — ${showEditRole.display_name}` : 'Yeni rol'}</h3>
            <ErrorBox text={error} />
            <form onSubmit={saveRole}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', marginBottom: 16 }}>
                <div className="input-group" style={{ marginBottom: 0, flex: 1 }}><label>Rol adı</label><input className="input" value={roleForm.display_name} onChange={e => setRoleForm({ ...roleForm, display_name: e.target.value })} placeholder="Örn. İçerik editörü" required /></div>
                <div className="input-group" style={{ marginBottom: 0 }}><label>Renk</label>
                  <input type="color" value={roleForm.color} onChange={e => setRoleForm({ ...roleForm, color: e.target.value })} style={{ width: 52, height: 40, borderRadius: 8, border: 'none', background: 'var(--surface3)', cursor: 'pointer', padding: 4 }} />
                </div>
              </div>
              <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--link)', marginBottom: 10 }}>Yetkiler</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: '46vh', overflowY: 'auto', marginBottom: 18 }}>
                {MODULES.map(mod => {
                  const perms = roleForm.permissions?.[mod.key] || {};
                  const allOn = mod.actions.every(a => perms[a]);
                  return (
                    <div key={mod.key} style={{ background: 'var(--bg2)', borderRadius: 10, padding: '10px 12px' }}>
                      <div className="flex-between" style={{ marginBottom: 8 }}>
                        <span style={{ fontWeight: 600 }}>{mod.label}</span>
                        <label className="flex-center gap-6" style={{ fontSize: 12.5, color: 'var(--text3)', cursor: 'pointer' }}>
                          Tümü<span className="toggle"><input type="checkbox" checked={allOn} onChange={e => setAllModule(mod.key, e.target.checked)} /><span className="toggle-slider" /></span>
                        </label>
                      </div>
                      <div className="flex" style={{ flexWrap: 'wrap', gap: 6 }}>
                        {mod.actions.map(ac => (
                          <button type="button" key={ac} onClick={() => togglePerm(mod.key, ac)} className="chip"
                            style={{ border: 'none', cursor: 'pointer', fontSize: 12.5, padding: '5px 11px', background: perms[ac] ? 'var(--accent)' : 'var(--surface3)', color: perms[ac] ? '#fff' : 'var(--text2)' }}>
                            {perms[ac] && <Ic n="check" s={12} sw={3} />}{ACTION_LABELS[ac]}
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="flex gap-8" style={{ justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={closeRole}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Kaydediliyor…' : 'Kaydet'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
